define('components/stratemanager/views/StrateManagerView', [
    'components/stratemanager/views/StrateNavView',
    'components/factory/Factory',
    'components/stratemanager/templates/stratemanager',
    'components/ecrinbridge/EcrinBridge'
], function(StrateNavView, Factory, stratemanagerTpl, EcrinBridge) {

    var StrateManagerView = Mazarine.View.extend({

        template: stratemanagerTpl,

        id: "strate-manager-region",

        strates: [],
        lastStrate: null,
        currentWeight: 0,
        totalWeight: 0,
        windowHeight: 0,

        /*
         * Render the strate manager view in the attach node.
         * And optionnaly render the navigation.
         */
        render: function() {
            this.$el.html(this.template(this.model.toJSON()));
            $(this.model.get('attach')).append(this.$el);
            this.delegateEvents();
            if (this.model.get('showMainNav') && !this.navView) {
                this.navView = new StrateNavView();
                if (this.model.get('shareConf')) {
                    var _model = Factory.createModelFromData(this.model.get('shareConf'));
                    var _view = Factory.createViewFromModel(_model);

                    this.$('.js-maz-strate-nav-item-share .maz-strate-nav-label').append(_view.render().el);
                    _view.afterRender();
                }
            }

            this.updateScreenHeight();
        },

        /*
         * Loop on each strate of the strate list and call addStrate
         * -> stratesList: array of view, and optionnal navigation informations
         */
        addStratesList: function(stratesList) {
            this.totalWeight = stratesList.length;

            _.each(stratesList, _.bind(function(strate, index) {
                this.addStrate(strate.view, strate.navName, strate.showNav, strate.navClassName, strate.offset);
            }, this));
        },

        /*
         * Append strate on the DOM, and wait for the strate to be ready
         * -> strate: view with a render function and an unique viewId
         * -> _navName: the name that will appear in the navView
         * -> _showNav: boolean that determined if the strate should appear in the nav or not
         * -> _navClassName: class that will be had to the nav item
         * -> _offset: offset that will be add to the strate position
         */
        addStrate: function(strate, _navName, _showNav, _navClassName, _offset) {
            this.$('.maz-strate-manager-wrapper').append(strate.render().$el.addClass('maz-strate'));
            this.listenTo(strate.model, 'change:isReady', _.bind(this.onStrateReady, this));

            this.strates.push({ "viewId": strate.getViewId(), "view": strate, "position": strate.$el.offset(), "offset": _offset });

            if (strate.afterRender) {
                strate.afterRender();
            }

            if (this.navView && _showNav) {
                this.navView.addNavItem({ "viewId": strate.getViewId(), "name": _navName, "link": '#section/' + strate.getViewId(), "navClassName": _navClassName });
            }

            this.updateStratePosition();
            this.updateStrateHeight();
        },

        /*
         * Remove the strate from the DOM and from the nav
         * -> strateId: id that match with the viewId of the view
         */
        removeStrate: function(strateId) {
            this.getStrate(strateId).view.$el.remove();

            if (this.navView) {
                this.navView.removeNavItem(strateId);
            }

            this.strates = _.reject(this.strates, function(item) {
                return item.viewId === strateId;
            });

            this.updateStratePosition();
            this.updateStrateHeight();
        },

        /*
         * Callback called when a strate isReady. It allow to update strate position when all strates are ready.
         * It also call a callback onAllStratesReady.
         */
        onStrateReady: function(model, isReady) {
            if( isReady ) {
                this.currentWeight++;
            } else {
                this.currentWeight--;
            }

            if (this.currentWeight === this.totalWeight) {
                this.updateStratePosition();
                this.updateStrateHeight();

                var callback = this.model.get('onReady');
                if (callback) {
                    callback();
                }

                _.each( this.strates, function( strate, index ) {
                    if( strate.view.onAllStratesReady ){
                        strate.view.onAllStratesReady();
                    }
                });
            }
        },

        /*
         * Return an object with the strate view.
         * -> strateId: id that match with the viewId of the view
         */
        getStrate: function(strateId) {
            return _.findWhere(this.strates, {"viewId": strateId});
        },

        /*
         * Add a navigation item to the navigation view
         */
        addNavItem: function(navObj) {
            if (this.navView) {
                this.navView.addNavItem(navObj);
            }
        },

        /*
         * Calculate all strate position
         */
        updateStratePosition: function() {
            _.each(this.strates, function(item, index){
                item.position = item.view.$el.offset();
                item.position.top += item.offset ? parseInt( item.offset, 10 ) : (EcrinBridge.getHeaderHeight() * -1);
            });
        },

        /*
         * Calculate all strate height
         */
        updateStrateHeight: function() {
            _.each(this.strates, function(item, index) {
                var ecrin_offset = !item.offset ? EcrinBridge.getHeaderHeight() : 0;

                item.height = ecrin_offset + item.view.$el.outerHeight(true);
            });
        },

        /*
         * Calculate screen height
         */
        updateScreenHeight: function() {
            this.windowHeight = $(window).height();
        },

        /*
         * Return a specific strate position
         * -> strateId: id that match with the viewId of the view
         */
        getStratePosition: function(strateId) {
            var strate = this.getStrate(strateId);
            return strate ? strate.position : {"top": 0, "left": 0};
        },

        /*
         * Call the onEnter function of the currentView
         */
        enterCurrentStrate: function() {
            if (this.lastStrate && this.lastStrate.view.onEnter) {
                this.lastStrate.view.onEnter();
            }
        },

        /*
         * Call the onLeave function of the currentView
         */
        leaveCurrentStrate: function() {
            if (this.lastStrate && this.lastStrate.view.onLeave) {
                this.lastStrate.view.onLeave();
            }
        },

        /*
         * Get the current strate on each scroll change
         * e: event of the onScroll
         * onStrateChangeCallback: callback called when the currentView is different from the previous one
         */
        onScroll: function(e, onStrateChangeCallback) {
          this.throttledScrollAction = this.throttledScrollAction || _.throttle(function() {
            this.scrollAction(e, onStrateChangeCallback);
          }, 250);
          this.throttledScrollAction();
        },


        scrollAction: function(e, onStrateChangeCallback) {
            var currentItem = null;
            var navigation = document.querySelector("[data-view-id=navigation-view]");
            var navigationBottom = navigation.getBoundingClientRect().bottom;
            var scrollTop = navigationBottom + 10;
            // GET CURRENT STRATE ON SCREEN
            _.each(this.strates, function(item, index) {

                var br = item.view.el.getBoundingClientRect();

                var itemTop = br.top;
                var itemBottom = br.bottom;

                if (scrollTop >= itemTop && scrollTop <= itemBottom) {
                    currentItem = item;
                }

                if (itemTop <= (scrollTop + this.windowHeight) && itemBottom > scrollTop) {
                    if (item.view.inViewport) {
                        item.view.inViewport();
                    }
                } else {
                    if (item.view.outViewport) {
                        item.view.outViewport();
                    }
                }
            });

            if (currentItem !== null) {

                if (_.isFunction(currentItem.view.onScroll)) {
                    currentItem.view.onScroll(e);
                }

                // CHANGE STRATE
                if (!this.lastStrate || this.lastStrate !== currentItem) {

                    if (this.navView) {
                        this.navView.selectNavItem(currentItem.viewId);
                    }
                    if (onStrateChangeCallback) {
                        onStrateChangeCallback(currentItem);
                    }
                    if (this.lastStrate && this.lastStrate.view.onLeave) {
                        this.lastStrate.view.onLeave();
                    }
                    if (currentItem.view.onEnter) {
                        currentItem.view.onEnter();
                    }
                    this.lastStrate = currentItem;
                }
            } else {
                if (this.lastStrate && this.lastStrate.view.onLeave) {
                    this.lastStrate.view.onLeave();
                }
                if (onStrateChangeCallback) {
                    onStrateChangeCallback(null);
                }
                this.lastStrate = null;
            }
        },

        /*
         * Call the on resize of each strate and update strate position
         */
        onResize: function(e) {
            this.updateStratePosition();
            this.updateStrateHeight();
            this.updateScreenHeight();

            _.each(this.strates, function(item, index){
                if (_.isFunction(item.view.onResize)) {
                    item.view.onResize(e);
                }
            });
        }
    });

    return StrateManagerView;
});
